"use strict";

var _toConsumableArray = require("/codebuild/output/src4172266550/src/jag-website/node_modules/@babel/runtime/helpers/toConsumableArray.js");
var _defineProperty = require("/codebuild/output/src4172266550/src/jag-website/node_modules/@babel/runtime/helpers/defineProperty.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
require("core-js/modules/es.array.flat-map.js");
require("core-js/modules/es.array.unscopables.flat-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return getAllConfigs;
  }
});
var _defaultConfigStubJs = /*#__PURE__*/_interopRequireDefault(require("../../stubs/defaultConfig.stub.js"));
var _featureFlags = require("../featureFlags");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function getAllConfigs(config) {
  var ref;
  var configs = ((ref = config === null || config === void 0 ? void 0 : config.presets) !== null && ref !== void 0 ? ref : [_defaultConfigStubJs.default]).slice().reverse().flatMap(function (preset) {
    return getAllConfigs(preset instanceof Function ? preset() : preset);
  });
  var features = {
    // Add experimental configs here...
    respectDefaultRingColorOpacity: {
      theme: {
        ringColor: function ringColor(_ref) {
          var theme = _ref.theme;
          return _objectSpread({
            DEFAULT: "#3b82f67f"
          }, theme("colors"));
        }
      }
    },
    disableColorOpacityUtilitiesByDefault: {
      corePlugins: {
        backgroundOpacity: false,
        borderOpacity: false,
        divideOpacity: false,
        placeholderOpacity: false,
        ringOpacity: false,
        textOpacity: false
      }
    }
  };
  var experimentals = Object.keys(features).filter(function (feature) {
    return (0, _featureFlags.flagEnabled)(config, feature);
  }).map(function (feature) {
    return features[feature];
  });
  return [config].concat(_toConsumableArray(experimentals), _toConsumableArray(configs));
}